import { useSelector, useDispatch } from 'react-redux';
import { getRecommendedQuestionsForAgent } from '../widget-data/selectors/getRecommendedQuestionsForAgent';
import { getColoring } from '../selectors/widgetDataSelectors/getColoring';
// @ts-expect-error untyped file
import { publishVisitorMessage } from '../pubsub/actions/publishVisitorMessage';
import { loadStagedThread } from '../navigation/actions/loadStagedThread';
import { getKnowledgeBaseEnabled } from '../selectors/widgetDataSelectors/getKnowledgeBaseEnabled';
import { toggleOpen } from '../actions/WidgetActions';
import { trackInteraction } from '../usage-tracking/actions/trackInteraction';
import { EVENT_NAMES } from '../usage-tracking/constants/eventNames';
import { getIsAIChatbot } from '../selectors/widgetDataSelectors/getIsAIChatbot';
import { getIsMobile } from '../selectors/getIsMobile';
import { setHasClickedWelcomePagePrompts } from '../ai-prompt-recommendations/reducers/aiPromptsInteractionSlice';
import Raven from 'raven-js';
export const useAIPromptRecommendations = ({
  clickedFrom,
  shouldOpenWidget = false,
  shouldLoadStagedThread = true,
  errorMessage = 'Failed to publish message from AI prompt'
}) => {
  const dispatch = useDispatch();
  const recommendedQuestionsForAgent = useSelector(getRecommendedQuestionsForAgent);
  const coloring = useSelector(getColoring);
  const knowledgeBaseEnabled = useSelector(getKnowledgeBaseEnabled);
  const isAIChatBot = useSelector(getIsAIChatbot);
  const isMobile = useSelector(getIsMobile);
  const handlePromptClick = text => {
    const richText = `<div>${text}</div>`;
    dispatch(setHasClickedWelcomePagePrompts({
      hasClicked: true
    }));
    if (shouldLoadStagedThread && knowledgeBaseEnabled) {
      dispatch(loadStagedThread());
    }
    const publishPromise = dispatch(publishVisitorMessage({
      text,
      richText,
      quickReply: null,
      fileAttachment: null
    }));
    if (shouldOpenWidget) {
      publishPromise.then(() => {
        dispatch(toggleOpen({
          isOpened: true,
          isUser: true,
          openedFrom: 'AI prompt recommendations outside chat'
        }));
      }).catch(() => {
        Raven.captureMessage(errorMessage);
      });
    } else {
      publishPromise.catch(() => {
        Raven.captureMessage(errorMessage);
      });
    }
  };
  const handlePromptTrack = () => {
    dispatch(trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
      action: 'ai prompt recommendation clicked',
      clickedFrom
    }));
  };
  return {
    recommendedQuestionsForAgent,
    coloring,
    isAIChatBot,
    isMobile,
    handlePromptClick,
    handlePromptTrack
  };
};